export default __webpack_public_path__ + "static/media/tkit-2-sm.92611e22.svg";